import { Component, OnInit } from '@angular/core';
import { IOAuthService } from 'src/app/_Services/user/iOAuthService';

@Component({
  selector: 'app-conflict',
  templateUrl: './conflict.component.html',
  styleUrls: ['./conflict.component.scss']
})
export class ConflictComponent {
  title: string = 'Conflict Detected';
  message: string = 'There was a conflict with your request. Please try again later.';
  constructor(private oAuthService: IOAuthService) {

 }
  async logout(){
    await this.oAuthService.logOut();
  }
}
